import React from 'react';
import {Btn} from '../../AbstractElements'

const style2 = { width: 60, fontSize: 14, padding: 4 };


//Doctor Department Settings
export const doctordepartment = [
    {
        id: 1,
        doctordepartment: "Pediatric dentistry",
        description:"Pedodontist",
        action: 
        ({ LargeModaltoggle }) => (
            <span>
                <Btn
                    attrBtn={{
                        style: style2,
                        color: 'success',
                        className: 'btn btn-xs',
                        type: 'button',
                        onClick: LargeModaltoggle
                    }}
                >
                    Edit
                </Btn>
            </span>
        )
    },
];

export const tableColumns = [
    {
        name: '#',
        selector: row => row['id'],
        sortable: true,
        center: false,
    },
    {
        name: 'Department',
        selector: row => row['doctordepartment'],
        sortable: true,
        center: false,
    },
    {
        name: 'Action',
        selector: row => <row.action LargeModaltoggle={row.LargeModaltoggle} />,
        sortable: false,
        center: true,
    },
];



//Staff Category Settings
export const staffCategory = [
    {
        id: 1,
        staffcategory: "Manager",
        action: 
        ({ LargeModaltoggle }) => (
            <span>
                <Btn
                    attrBtn={{
                        style: style2,
                        color: 'success',
                        className: 'btn btn-xs',
                        type: 'button',
                        onClick: LargeModaltoggle
                    }}
                >
                    Edit
                </Btn>
            </span>
        )
    },
];

export const stafftableColumns = [
    {
        name: '#',
        selector: row => row['id'],
        sortable: true,
        center: false,
    },
    {
        name: 'Category',
        selector: row => row['staffcategory'],
        sortable: true,
        center: false,
    },
    {
        name: 'Action',
        selector: row => <row.action LargeModaltoggle={row.LargeModaltoggle} />,
        sortable: false,
        center: true,
    },
];


//Pharmacy category settings

export const pharmacyCategory = [
    {
        id: 1,
        pharmacycategory: "Tablet",
        action: 
        ({ LargeModaltoggle }) => (
            <span>
                <Btn
                    attrBtn={{
                        style: style2,
                        color: 'success',
                        className: 'btn btn-xs',
                        type: 'button',
                        onClick: LargeModaltoggle
                    }}
                >
                    Edit
                </Btn>
            </span>
        )
    },
];

export const pharmacytableColumns = [
    {
        name: '#',
        selector: row => row['id'],
        sortable: true,
        center: false,
    },
    {
        name: 'Category',
        selector: row => row['pharmacycategory'],
        sortable: true,
        center: false,
    },
    {
        name: 'Action',
        selector: row => <row.action LargeModaltoggle={row.LargeModaltoggle} />,
        sortable: false,
        center: true,
    },
];

//Inventory Category settings

export const inventoryCategory = [
    {
        id: 1,
        inventorycategory: "Materials",
        action: 
        ({ LargeModaltoggle }) => (
            <span>
                <Btn
                    attrBtn={{
                        style: style2,
                        color: 'success',
                        className: 'btn btn-xs',
                        type: 'button',
                        onClick: LargeModaltoggle
                    }}
                >
                    Edit
                </Btn>
            </span>
        )
    },
];

export const inventorytableColumns = [
    {
        name: '#',
        selector: row => row['id'],
        sortable: true,
        center: false,
    },
    {
        name: 'Category',
        selector: row => row['inventorycategory'],
        sortable: true,
        center: false,
    },
    {
        name: 'Action',
        selector: row => <row.action LargeModaltoggle={row.LargeModaltoggle} />,
        sortable: false,
        center: true,
    },
];

//Medical Report Type

export const reportType = [
    {
        id: 1,
        reporttype: "X-ray",
        action: 
        ({ LargeModaltoggle }) => (
            <span>
                <Btn
                    attrBtn={{
                        style: style2,
                        color: 'success',
                        className: 'btn btn-xs',
                        type: 'button',
                        onClick: LargeModaltoggle
                    }}
                >
                    Edit
                </Btn>
            </span>
        )
    },
];

export const reportTypetableColumns = [
    {
        name: '#',
        selector: row => row['id'],
        sortable: true,
        center: false,
    },
    {
        name: 'Medical Report Type',
        selector: row => row['reporttype'],
        sortable: true,
        center: false,
    },
    {
        name: 'Action',
        selector: row => <row.action LargeModaltoggle={row.LargeModaltoggle} />,
        sortable: false,
        center: true,
    },
];